var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLifestyleTips = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Newspaper-Read--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Newspaper Read Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.73 9.64a0.48 0.48 0 0 0 -0.32 0.45 0.49 0.49 0 0 0 0.3 0.48 10.65 10.65 0 0 0 2.29 0.93 10.65 10.65 0 0 0 2.29 -0.93 0.51 0.51 0 0 0 0.31 -0.47 0.5 0.5 0 0 0 -0.33 -0.46 2.13 2.13 0 0 1 -0.07 -1.5A5.37 5.37 0 0 0 15.61 4 3.7 3.7 0 0 0 12 0a3.7 3.7 0 0 0 -3.61 4 5.36 5.36 0 0 0 1.39 4.12 2.08 2.08 0 0 1 -0.05 1.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87 10.53a1.46 1.46 0 0 0 -1.37 -0.19L12 13l-7.5 -2.66a1.46 1.46 0 0 0 -1.37 0.19 1.52 1.52 0 0 0 -0.63 1.22v7.9a1.5 1.5 0 0 0 1 1.41l8.17 2.88a0.94 0.94 0 0 0 0.66 0l8.17 -2.88a1.5 1.5 0 0 0 1 -1.41v-7.9a1.52 1.52 0 0 0 -0.63 -1.22ZM4.5 12.81a0.23 0.23 0 0 1 0.11 -0.2 0.25 0.25 0 0 1 0.22 0l6 2.12a0.26 0.26 0 0 1 0.17 0.24v6.3a0.26 0.26 0 0 1 -0.11 0.21 0.25 0.25 0 0 1 -0.22 0l-6 -2.12a0.25 0.25 0 0 1 -0.17 -0.23Zm15 6.31a0.25 0.25 0 0 1 -0.17 0.23l-6 2.12a0.25 0.25 0 0 1 -0.22 0 0.26 0.26 0 0 1 -0.11 -0.21v-6.3a0.26 0.26 0 0 1 0.17 -0.24l6 -2.12a0.25 0.25 0 0 1 0.22 0 0.23 0.23 0 0 1 0.11 0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLifestyleTips);
export default ForwardRef;